export default __webpack_public_path__ + "static/pict6Placeholder-c727a456723737fea97c8738721315da.png";